import { render } from "./AboFeatureBadge.vue?vue&type=template&id=6aab461f&scoped=true"
import script from "./AboFeatureBadge.vue?vue&type=script&lang=js"
export * from "./AboFeatureBadge.vue?vue&type=script&lang=js"

import "./AboFeatureBadge.vue?vue&type=style&index=0&id=6aab461f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aab461f"]])

export default __exports__